import script from "./CustomInputField.vue?vue&type=script&lang=ts&setup=true"
export * from "./CustomInputField.vue?vue&type=script&lang=ts&setup=true"

import "./CustomInputField.vue?vue&type=style&index=0&id=89e109c6&scoped=true&lang=scss"

import exportComponent from "/Users/jnshul/Documents/tagluffa_i_vue3/main_page/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-89e109c6"]])

export default __exports__